import { z } from 'zod';

/**
 * Incoterms 2020 (ICC) — Lieferbedingungen auf Belegen (Verkauf + Einkauf).
 * Gespeichert wird nur der Code; der „benannte Ort" steht separat im
 * Freitextfeld Erfüllungsort (z. B. „DAP · Kläranlage Wien").
 */
export const INCOTERMS = [
  'EXW',
  'FCA',
  'FAS',
  'FOB',
  'CFR',
  'CIF',
  'CPT',
  'CIP',
  'DAP',
  'DPU',
  'DDP',
] as const;

export const incotermSchema = z.enum(INCOTERMS);
export type Incoterm = z.infer<typeof incotermSchema>;

/** Deutsche Kurzbezeichnungen für die Dropdown-Anzeige im Editor. */
export const INCOTERM_LABELS: Record<Incoterm, string> = {
  EXW: 'EXW – Ab Werk',
  FCA: 'FCA – Frei Frachtführer',
  FAS: 'FAS – Frei Längsseite Schiff',
  FOB: 'FOB – Frei an Bord',
  CFR: 'CFR – Kosten und Fracht',
  CIF: 'CIF – Kosten, Versicherung, Fracht',
  CPT: 'CPT – Frachtfrei',
  CIP: 'CIP – Frachtfrei versichert',
  DAP: 'DAP – Geliefert benannter Ort',
  DPU: 'DPU – Geliefert entladen',
  DDP: 'DDP – Geliefert verzollt',
};
